import styled from 'styled-components';
import { breakpoints, fonts, pxToCssFont } from '@vfit/shared/themes';

export const Container = styled.div<{ reducedBox?: boolean; timeToShow?: number }>`
  background: linear-gradient(45deg, #222 0%, #25282b 100%);
  padding: ${(props) => (props.reducedBox ? '8px' : '24px')};
  padding-right: 16px;
  display: flex;
  position: absolute;
  flex-direction: ${(props) => (props.reducedBox ? 'row' : 'column')};
  gap: 8px;
  border-radius: ${(props) => (props.reducedBox ? '40px' : '20px')};
  color: white;
  z-index: 2;
  top: 9px;
  right: 9px;
  left: 9px;
  animation: fade-in 1s ease-in forwards 0s;

  @media (min-width: ${breakpoints.tablet}) {
    width: ${(props) => (props.reducedBox ? 'fit-content' : 'inherit')};
    left: ${(props) => (props.reducedBox ? '0' : '9px')};
    right: ${(props) => (props.reducedBox ? '0' : '9px')};
    margin: ${(props) => (props.reducedBox ? 'auto' : 'inherit')};
  }

  @media (min-width: ${breakpoints.desktop}) {
    max-width: ${(props) => (props.reducedBox ? 'inherit' : '515px')};
    margin: ${(props) => (props.reducedBox ? '0 80px 0 0' : '0 80px 104px 0')};
    ${(props) =>
      props.reducedBox
        ? `
      top: 24px;
      left: inherit;
      right: 0;
      `
        : `
        top: inherit;
        left: inherit;
        bottom: 24px;
        right: 0;
      `}
  }

  @keyframes fade-in {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }
`;

export const UpperContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  .closing-icon {
    cursor: pointer;
  }
`;

export const ImageContainer = styled.div<{ reducedBox?: boolean }>`
  width: ${(props) => (props.reducedBox ? '106.82px' : '150px')};
  img {
    max-height: ${(props) => (props.reducedBox ? '40px' : '30px')};
  }
`;

export const BottomContainer = styled.div<{ reducedBox?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${(props) => (props.reducedBox ? '4px' : '8px')};
  letter-spacing: 0;
  justify-content: center;
  z-index: 99;

  @media (min-width: ${breakpoints.tablet}) {
    flex-direction: ${(props) => (props.reducedBox ? 'row' : 'column')};
    ${(props) => props.reducedBox && 'align-items: center;'}
  }
`;

export const Title = styled.h1<{ reducedBox?: boolean }>`
  margin: 0;
  font-family: ${fonts.vodafone};
  ${(props) =>
    props.reducedBox
      ? `${pxToCssFont(14, 16.8)};
      font-weight:400;
      display:inline;
      `
      : `${pxToCssFont(28, 36)}
      font-weight: 800;
      `}

  @media (min-width: ${breakpoints.tablet}) {
    ${(props) =>
      props.reducedBox &&
      `${pxToCssFont(16, 22)};
      font-weight:400;
      `}
  }
`;

export const Description = styled.h4`
  font-family: ${fonts.vodafone};
  font-weight: 400;
  margin: 0;
  ${pxToCssFont(18, 24)}
  margin-bottom: 8px;

  b {
    ${pxToCssFont(22, 32)}
    font-weight: 800;
  }

  p {
    margin: 0;
  }
`;

export const ButtonContainer = styled.div<{ reducedBox?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 700;
  ${pxToCssFont(14, 22.1)}
  letter-spacing: 0.5px;
  text-transform: uppercase;
  ${(props) => props.reducedBox && 'display: none;'}

  button {
    width: 100%;
    background-color: transparent !important;
    color: white !important;
    border-color: white !important ;

    :hover,
    :active {
      background-color: #d9d9d9 !important ;
      color: black !important ;
      border-color: transparent !important ;
    }

    :active {
      background-color: #b3b3b3 !important ;
    }
  }

  @media (min-width: ${breakpoints.tablet}) {
    button {
      width: auto;
    }
  }

  @media (min-width: ${breakpoints.desktop}) {
    button {
      width: auto;
    }
  }
`;

export const CustomLink = styled.span`
  cursor: pointer;
  font-weight: 700;
  ${pxToCssFont(14, 16.8)}
  display: block;
  letter-spacing: 0;
  text-decoration: underline;
  margin-left: 2px;
  font-family: ${fonts.vodafone};

  @media (min-width: ${breakpoints.tablet}) {
    ${pxToCssFont(16, 22)}
    display: inline;
  }
`;
